<template>
  <div class="home">
    <LoaderComponent v-show="loading" />
    <HeaderView />
    <section
      class="dashboard-page-main-sec order-page-main-sec track-order-main-sec edited-order-main-sec agency-design-grid-right draft-order-page-sec"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="text-heading-2">Order Approvals</div>
          <div class="editor-dashboard-sec-2 approval-list-sec draft-order-sec">
            <!-- <div class="order-list-tabs">
              <div class="order-input-field">
                <div class="date-picker-box">
                  <div class="form-row">
                    <div class="col-md-12">
                      <label>Filter by date</label>
                      <div
                        class="input-daterange input-group"
                        id="m_datepicker"
                      >
                        <DatePickerComponent
                          :minDate="minDate"
                          :maxDate="maxDate"
                          :options="options"
                          :position="position"
                          :refVal="'datepickerMenu'"
                          :orderDate="order_date"
                          @getSearchData="getSearchData"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="download-icon-list">
                  <div @click="downloadFile()" class="top_icons">
                    <i
                      class="fas fa-file-export"
                      v-b-tooltip.hover.top="'Export CSV'"
                    ></i>
                  </div>
                  <div class="per-page-right-box">
                    <div class="select-item">
                      <select
                        @change="changePagination()"
                        v-model="filter.per_page"
                      >
                        <option>50</option>
                        <option>100</option>
                        <option>200</option>
                        <option>500</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
            <div class="table-responsive">
              <table class="addon-table">
                <tr>
                  <th @click="sortByColumn('order_id')">
                    Order Id
                    <span><i class="fas fa-sort"></i></span>
                  </th>
                  <th>
                    Old Links
                  </th>
                  <th>
                    Updated Links
                  </th>
                  <th>
                    New links
                  </th>
                  <th>
                    Old Price
                  </th>
                  <th>
                    New Price
                  </th>
                  <th>Action</th>
                </tr>
                <tr v-for="order in edited_orders" :key="order.id">
                  <td>{{ order.order_id }}</td>
                  <td>{{ order.old_links_count }}</td>
                  <td>{{ order.updated_links_count }}</td>
                  <td>{{ order.new_links_count }}</td>
                  <td>{{ numberFormat(order.old_price, "currency") }}</td>
                  <td>{{ numberFormat(order.new_price, "currency") }}</td>
                  <td>
                    <div class="btn-box">
                      <a 
                        :href="buildOrderDetailUrl(order.id)"
                      >
                        <i class="fas fa-eye"></i>
                      </a>
                    </div>
                  </td>
                </tr>
              </table>
              <div class="total-records-list">
                <p>Showing {{ rows.length }} of {{ totalRecords }} records</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pagination-list">
        <paginate
          :click-handler="getEditedOrder"
          :prev-text="'Prev'"
          :next-text="'Next'"
          :page-count="filter.last_page"
          :page-range="3"
          :margin-pages="2"
          :container-class="'className'"
          :records="filter.length"
          v-model="filter.page"
          :per-page="filter.per_page"
        >
        </paginate>
      </div>
    </section>
  </div>
</template>

<script>
import HeaderView from "@/components/layout/HeaderComponent.vue";
import LoaderComponent from "@/components/LoaderComponent.vue";
// import DraftOrderView from "@/components/dashboardComponents/draftOrder.vue";
import { numberFormat } from "@/prod.js";
import Paginate from "vuejs-paginate-next";
// import DatePickerComponent from "@/components/DatePickerComponent.vue";

export default {
  components: {
    // DatePickerComponent,
    HeaderView,
    LoaderComponent,
    // DraftOrderView,
    Paginate,
  },
  mounted() {
    this.getEditedOrder();
  },
  data() {
    return {
      numberFormat,
      loading: false,
      date: new Date(),
      options: {
        format: "MM/DD/YYYY",
        useCurrent: false,
      },
      order_date: "",
      minDate: new Date(new Date().setMonth(new Date().getMonth() - 1)),
      maxDate: new Date(new Date().setMonth(new Date().getMonth() + 1)),
      filter: {
        s: "",
        e: "",
        columnTo: "id",
        orderBy: "desc",
        per_page: 50,
        page: 1,
        last_page: 1,
        length: "",
      },
      totalRecords: 0,
      rows: [],
      paginationData: {},
      edited_orders: [],
      selectedRange: "",
      ranges: {
        Today: [new Date(), new Date()],
        Yesterday: [
          new Date(new Date().setDate(new Date().getDate() - 1)),
          new Date(new Date().setDate(new Date().getDate() - 1)),
        ],
        "Last 7 Days": [
          new Date(new Date().setDate(new Date().getDate() - 7)),
          new Date(),
        ],
        "Last 30 Days": [
          new Date(new Date().setDate(new Date().getDate() - 30)),
          new Date(),
        ],
        "This Month": [
          new Date(new Date().getFullYear(), new Date().getMonth(), 1),
          new Date(),
        ],
        "Last Month": [
          new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
          new Date(new Date().getFullYear(), new Date().getMonth(), 0),
        ],
        "This Year": [new Date(new Date().getFullYear(), 0, 1), new Date()],
        "Custom Range": [new Date(), new Date()],
      },
      position: "left",
    };
  },
  methods: {
    getSearchData(value) {
      this.order_date = value;
      this.getEditedOrderSearch();
    },
    buildOrderDetailUrl(id) {
      const query = this.$route.query;
      const queryString = Object.keys(query).length
        ? "?" + new URLSearchParams(query).toString()
        : "";
      return `/order-opproval-links/${id}${queryString}`;
    },
    async getEditedOrder() {
      this.loading = true;
      this.filter.s = this.order_date ? this.order_date[0] : "";
      this.filter.e = this.order_date ? this.order_date[1] : "";
      try {
        let res = await this.$store.dispatch(
          "Product/getEditedOrderAction",
          this.filter
        );
        this.edited_orders = res.data;
        this.paginationData = res;
        this.totalRecords = res.meta.total;
        this.rows = res.data;
        this.filter.page = res.meta.current_page;
        this.filter.per_page = res.meta.per_page;
        this.filter.last_page = res.meta.last_page;
        this.filter.length = res.meta.total;
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },

    changePagination() {
      this.filter.page = 1;
      this.getEditedOrder();
    },

    getEditedOrderSearch() {
      this.filter.page = 1;
      this.getEditedOrder();
    },

    sortByColumn(column) {
      this.filter.columnTo = column;
      this.filter.orderBy = this.filter.orderBy == "asc" ? "desc" : "asc";
      this.getEditedOrder();
    },
  },
};
</script>
